export enum GlobalBaseValueDefinitionId {
    GRAPE_SUPPLIER = '865382ea-d031-5684-883b-05c3fd8e4d63',
    WINERY = 'd5f9ff39-1592-55c1-9a6e-889908430a36',
    EU_OKO_VO = '014b81de-9708-51c3-835b-0b187d897660',
    RECHTSVORSCHRIFTEN = '933cc771-69c4-52d0-a58f-261c265b959f',
    KONDITIONALITÄT = 'c8f46408-7a22-578c-bfc3-80947032f325',
    OR1A = '8da050ac-bf6b-5e84-95cc-f4c0635ac5c5',
    OR1C_ANLAGE = '310d0701-3aaa-57c6-a68e-6ceb4388be5d',
    OR6_BEWIRTSCHAFTUNG = '043c850e-d12a-566d-8e0e-cfe40ec329aa',
    OR7_ANWENDUNG = 'a7b6cece-52fe-5193-be76-97b201f71af2',
    D2_OKOLOGISCHER = '30268548-d017-5c91-992c-0c478ec6538b',
    E11_HERBIZIDFREIE = 'ed041310-c80b-56a4-8342-4b8b848afb13',
    ECOVIN = '4a8dd71c-0192-5c27-b8e2-9283c3456e9d',
    BIOLAND = '3b86cdff-3834-53eb-bd59-25dd70539061',
    DEMETER = '31429342-6171-5ce1-abd3-6174555a685b',
    NATURLAND = '9334a69a-0611-579c-b1af-beef0848b9bb',
    FAIR_CHOICE = '28b63059-9d5b-5cc7-8cdb-29bfe95ece0e',
    QZBW = '16cbf11b-b486-50bd-8343-21a03f91fbc1',

    // Note that at the moment this base value does not exist in NWBW. This is only to not
    // have a compilation error.
    GLYPHOSATE = '21036553-9bb1-4ce1-9adb-1037a5c3a3a8',
}
